<template>
  <div>
    <!--begin::Main-->
    <!--begin::Header Mobile-->
    <ui-header-mobile></ui-header-mobile>
    <!--end::Header Mobile-->
    <div class="d-flex flex-column flex-root">
      <!--begin::Page-->
      <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <ui-aside></ui-aside>
        <!--end::Aside-->
        <!--begin::Wrapper-->
        <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
          <ui-header></ui-header>
          <!--begin::Content-->
          <!-- <Spinner v-if="loading" class="py-5"></Spinner> -->
          <router-view v-if="!loading"></router-view>
          <!--end::Content-->
          <!--begin::Footer-->
          <ui-footer></ui-footer>
          <!--end::Footer-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Page-->
    </div>
    <!--end::Main-->
    <ui-scrolltop></ui-scrolltop>
  </div>
</template>
<script>
import Spinner from "../components/Spinner.vue";
import UiHeader from "@/components/layout/UiHeader";
import UiHeaderMobile from "@/components/layout/UiHeaderMobile";
import UiAside from "@/components/layout/UiAside";
import UiFooter from "@/components/layout/UiFooter";
// import UiUserPanel from '@/components/layout/UiUserPanel';
import UiScrolltop from "@/components/layout/UiScrolltop";
import { mapState } from "vuex";

export default {
  components: {
    UiHeader,
    UiHeaderMobile,
    UiAside,
    UiFooter,
    // UiUserPanel,
    UiScrolltop,
    Spinner,
  },
  computed: {
    ...mapState("layout", ["loading"]),
  },
  async created() {
    if (this.loading) {
      try {
        const response = await this.axios.post("auth/verify");
        this.$store.commit("auth/updateUser", response.data.content);
        this.$store.commit("layout/updateLoading", false);
      } catch (error) {
        this.$store.dispatch("auth/logout");
        this.$router.push({ name: "auth.login" });
      }
    } else {
      this.$router.replace({ query: {} });
    }
  },
  async mounted() {
    const vm = this;
    // Initialization
    KTUtil.ready(function() {
      ////////////////////////////////////////////////////
      // Layout Base Partials(mandatory for core layout)//
      ////////////////////////////////////////////////////

      // Init Desktop & Mobile Headers
      KTLayoutHeader.init("kt_header", "kt_header_mobile");

      // Init Header Menu
      // KTLayoutHeaderMenu.init("kt_header_menu", "kt_header_menu_wrapper");

      // Init Header Topbar For Mobile Mode
      KTLayoutHeaderTopbar.init("kt_header_mobile_topbar_toggle");

      // Init Brand Panel For Logo
      KTLayoutBrand.init("kt_brand");

      // Init Aside
      KTLayoutAside.init("kt_aside");

      // Init Aside Menu Toggle
      KTLayoutAsideToggle.init("kt_aside_toggle");

      // Init Aside Menu
      KTLayoutAsideMenu.init("kt_aside_menu");

      // Init Subheader
      // KTLayoutSubheader.init('kt_subheader');

      // Init Content
      KTLayoutContent.init("kt_content");

      // Init Footer
      KTLayoutFooter.init("kt_footer");

      //////////////////////////////////////////////
      // Layout Extended Partials(optional to use)//
      //////////////////////////////////////////////

      // Init Scrolltop
      // KTLayoutScrolltop.init("kt_scrolltop"); •

      // Init Sticky Card
      // KTLayoutStickyCard.init("kt_page_sticky_card"); •

      // Init Stretched Card
      // KTLayoutStretchedCard.init("kt_page_stretched_card"); •

      // Init Code Highlighter & Preview Blocks(used to demonstrate the theme features)
      // KTLayoutExamples.init();

      // Init Demo Selection Panel
      // KTLayoutDemoPanel.init('kt_demo_panel');

      // Init Chat App(quick modal chat)
      // KTLayoutChat.init();

      // Init Quick Actions Offcanvas Panel
      // KTLayoutQuickActions.init('kt_quick_actions');

      // Init Quick Notifications Offcanvas Panel
      // KTLayoutQuickNotifications.init('kt_quick_notifications');

      // Init Quick Offcanvas Panel
      // KTLayoutQuickPanel.init('kt_quick_panel');

      // Init Quick User Panel
      // KTLayoutQuickUser.init('kt_quick_user');

      // Init Quick Search Panel
      // KTLayoutQuickSearch.init('kt_quick_search');

      // Init Quick Cart Panel
      // KTLayoutQuickCartPanel.init('kt_quick_cart');

      // Init Search For Quick Search Dropdown
      // KTLayoutSearch().init('kt_quick_search_dropdown');

      // Init Search For Quick Search Offcanvas Panel
      // KTLayoutSearchOffcanvas().init('kt_quick_search_offcanvas');
    });

    // $(function() {
    //   $('[data-toggle="tooltip"]').tooltip({
    //     trigger: "hover",
    //   });
    // });

    // refresh token

    // vm.refreshToken()

    // vm.interval = setInterval(async () => {
    // 	await vm.refreshToken()
    // }, ((60 * 15) * 1000))
  },
};
</script>
